import React, { useState, Dispatch, SetStateAction, useEffect } from "react";
import { toast } from "react-toastify";
import { useApi } from "../../../../../../hooks/useApi";
import ConfirmBtn from "../../../../../Button/ConfirmBtn";
import Loader from "../../../../../DefaultStyles/Loader";
import DropDown, { OptionType } from "../../../../../Filters/DropDown";
import {
  HasInitValueBox,
  ModalRowContentContainer,
} from "../../../../AlimTalk/AlimTalkModal";
import { ModalRow } from "../../../../Users/UserDetail/BlackListModal/BlackListModal";
import { ModalLabel } from "../../../../Users/UserDetail/CommentModal/TargetContainer";

interface PopupTemplateProps {
  type?: string;
  popupReason: number;
  dropdownDisabled: boolean;
  btnDisabled: boolean;
  templateValue: OptionType;
  setTemplateValue: Dispatch<SetStateAction<OptionType>>;
  setPreviewValue: Dispatch<
    SetStateAction<{
      title: string;
      content: string;
      buttonName: string;
      buttonLink: string;
      detail: string;
    }>
  >;
}

export default function PopupTemplateSection({
  type,
  popupReason,
  dropdownDisabled,
  btnDisabled,
  templateValue,
  setTemplateValue,
  setPreviewValue,
}: PopupTemplateProps) {
  const [getTemplate, setGetTemplate] = useState(false); // 팝업 템플릿 가져오기
  const [templateList, setTemplateList] = useState<OptionType[]>([]);

  const { response, loading, error } = useApi({
    method: "get",
    url: getTemplate ? `popup/message?type=${popupReason}` : undefined,
  });

  useEffect(() => {
    if (response?.status === 200) {
      const li: OptionType[] = [];

      if (response?.status === 200) {
        if (response?.data?.length > 0) {
          response?.data?.forEach((a: any) =>
            li.push({
              value: `${a.id}`,
              label: `${a.title}`,
            })
          );

          setTemplateList(li);
        }
      }
    }
  }, [response]);

  useEffect(() => {
    if (error?.data) {
      toast.error(error?.data ?? "팝업 템플릿을 조회하는 데에 실패하였습니다.");
    }
  }, [error]);

  return (
    <ModalRow>
      <ModalLabel>템플릿</ModalLabel>

      <ModalRowContentContainer>
        {type === "view" ? (
          <HasInitValueBox style={{ width: 230, height: "auto" }}>
            {templateValue?.label}
          </HasInitValueBox>
        ) : (
          <div onClick={() => setGetTemplate(true)}>
            <DropDown
              setDropDownValue={setTemplateValue}
              optionList={templateList}
              dropdownValue={templateValue}
              isDisabled={dropdownDisabled ?? false}
              boxWidth={230}
            />
          </div>
        )}

        {type === "input" && (
          <ConfirmBtn
            btnText="미리보기"
            btnColor="mint"
            btnClickEvent={() => {
              const templateData = response?.data?.find(
                (a: any) => a.id === +templateValue?.value!
              );

              setPreviewValue({
                title: templateData?.title ?? "",
                content: templateData?.content ?? "",
                detail: templateData?.detail ?? "",
                buttonName: templateData?.buttonname ?? "",
                buttonLink: templateData?.buttonLink ?? "",
              });
            }}
            isDisabled={btnDisabled ?? false}
          />
        )}

        {loading && <Loader />}
      </ModalRowContentContainer>
    </ModalRow>
  );
}
